import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-1.16415e-10 9.69872C0.106295 14.5776 4.09455 18.4999 8.99891 18.4999C13.9701 18.4999 18 14.47 18 9.49885C18 4.59546 14.0792 0.607827 9.20172 0.5V2.50064C12.9745 2.60796 16 5.70009 16 9.49885C16 13.3654 12.8655 16.4999 8.99891 16.4999C5.19917 16.4999 2.10643 13.4729 2.00062 9.69872H-1.16415e-10Z"
      fill="#0074DF"
    />
  </svg>,
  "ThreeQuarterCircle"
);
